// saga.js
import { all, takeEvery, put, call } from "redux-saga/effects";
import actions from "./actions";
import { axiosPrivate } from "../../Helpers/axios";

function* getMailsDataResponse({
  payload: { offset, limit, search, fromDate, toDate, agentId },
}) {
  try {
    const response = yield call(
      axiosPrivate,
      `/api/cou/dashboard/api/communication-channel?page=${
        offset ? offset : 1
      }&limit=${limit ? limit : 10}${search ? `&search=${search}` : ""}${
        fromDate ? `&fromDate=${fromDate}` : ""
      }${toDate ? `&toDate=${toDate}` : ""}${
        agentId ? `&agentId=${agentId}` : "PLUSONE"
      }`
    );
    yield put(
      actions.getMailsDataSuccess(response.data.data, response.data.data.total)
    );
  } catch (error) {
    yield put(actions.getMailsDataFailed(error));
  }
}


function* updateEmailRead({ payload: { data , agentId } }) {
  // console.log(agentId , data , "kam")
  // let agentId="PLUSONE"
try {
  const response = yield call(
    axiosPrivate.patch,
    `/api/ai/dashboard/communication-channel/updateReadMessage/${agentId}`,
    data
  );
  if (response.status === 201) {
    yield put(actions.updateEmailReadSuccess("Email Update successfully"));
  } else {
    yield put(actions.updateEmailReadFailed(response.data.message));
  }
} catch (error) {
  yield put(actions.updateEmailReadFailed(error?.response?.data?.message));
}
}

export default function* rootSaga() {
  yield all([takeEvery(actions.UPDATE_EMAIL_READ, updateEmailRead)]);
  yield all([takeEvery(actions.GET_MAILS_DATA, getMailsDataResponse)]);
}
